// WhatsApp Channel — Temple of Kulture treats this as a primary
// conversion pathway alongside the email newsletter.
//
// `WHATSAPP_CHANNEL_URL` is the canonical join link. The frontend
// fires a tracking call to the backend before redirecting, but it
// is non-blocking — if the network call fails the user still
// reaches the channel.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_CHANNEL_URL =
  "https://whatsapp.com/channel/0029Vaz3TIQ60eBjCw1mVJ3e";

export async function trackWhatsAppClick({
  pageSource,
  referralSource,
  email,
} = {}) {
  // Fire-and-forget. We don't await it inside the click handler so
  // the redirect feels instant.
  try {
    await axios.post(
      `${API}/whatsapp/click`,
      {
        page_source: pageSource || (typeof window !== "undefined" ? window.location.pathname : null),
        device_source:
          typeof navigator !== "undefined" ? navigator.userAgent : null,
        referral_source: referralSource,
        email: email || undefined,
      },
      { timeout: 4000 },
    );
  } catch (err) {
    // Silent — analytics shouldn't break the funnel.
    if (typeof console !== "undefined" && console.debug) {
      console.debug("whatsapp click tracking failed", err?.message);
    }
  }
}

export function openWhatsAppChannel(opts = {}) {
  // Open the channel in a new tab and fire tracking concurrently.
  trackWhatsAppClick(opts);
  if (typeof window !== "undefined") {
    window.open(WHATSAPP_CHANNEL_URL, "_blank", "noopener,noreferrer");
  }
}
